import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["title", "titleId", "subtitle", "subtitleId", "sticky", "onClose", "children"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Button from 'components/Button';
import StickyBox from 'components/StickyBox';
import Panel from 'components/Panel';
import PageTitle from 'components/PageTitle';
function ModalCloseButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  return /*#__PURE__*/React.createElement(Button, {
    position: "absolute",
    top: "xxs",
    right: "xxs",
    icon: "x",
    variant: "transparent",
    size: "large",
    onClick: onClick,
    title: t('actions_close_modal')
  });
}
function ModalHeadingPanel(_ref2) {
  var children = _ref2.children,
    sticky = _ref2.sticky,
    onClose = _ref2.onClose;
  var Wrapper = sticky ? StickyBox : Box;
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: Panel,
    forwardedAs: "header",
    position: sticky ? undefined : 'relative',
    borderTopRadius: "inherit"
  }, /*#__PURE__*/React.createElement(Box, {
    pr: 64
  }, children), onClose && /*#__PURE__*/React.createElement(ModalCloseButton, {
    onClick: onClose
  }));
}
function ModalHeadline(_ref3) {
  var title = _ref3.title,
    titleId = _ref3.titleId,
    subtitle = _ref3.subtitle,
    subtitleId = _ref3.subtitleId,
    sticky = _ref3.sticky,
    onClose = _ref3.onClose,
    children = _ref3.children,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(ModalHeadingPanel, {
    sticky: sticky,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(PageTitle, _extends({}, otherProps, {
    id: titleId
  }), title || children), subtitle && /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    id: subtitleId,
    pt: "xxs"
  }, subtitle));
}
export { ModalHeadingPanel, ModalCloseButton };
export default ModalHeadline;